import { render, staticRenderFns } from "./BudgetRangeSliderLegendInput.vue?vue&type=template&id=906cfbec&scoped=true"
import script from "./BudgetRangeSliderLegendInput.vue?vue&type=script&lang=js"
export * from "./BudgetRangeSliderLegendInput.vue?vue&type=script&lang=js"
import style0 from "./BudgetRangeSliderLegendInput.vue?vue&type=style&index=0&id=906cfbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906cfbec",
  null
  
)

export default component.exports